import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import type { ButtonProps } from "@circle-react-uikit/Button";
import { Button } from "@circle-react-uikit/Button";

export interface CloseButtonProps extends Omit<ButtonProps, "type"> {
  className?: string;
}

export const CloseButton = ({
  onClick,
  className = "",
  ...rest
}: CloseButtonProps) => (
  <Button
    type="button"
    variant="plain"
    small
    onClick={onClick}
    className={className}
    {...rest}
  >
    <span className="sr-only">{t("close")}</span>
    <Icon className={classNames("!text-dark")} type="20-close" size={20} />
  </Button>
);
